import React from 'react';
import { PageSection, PageSectionVariants, EmptyState, EmptyStateBody, EmptyStateHeader } from '@patternfly/react-core';

import { useSelector } from 'react-redux';

import '../customization-page.css';

import { useTranslation } from 'react-i18next';
import { CustomizationObjectType } from '../../../store/global-types/customization-types';
import { StoreState } from '../../../store/store';
import { appConfigSelectors } from '../../../store/appConfig/appConfigSlice';
import { adaptSelectors } from '../../../store/adapt/adaptSlice';
import AdaptCustomizationForm from './AdaptCustomizationForm';
import AdaptCustomizationToolbar from './AdaptCustomizationToolbar';


interface AdaptCustomizationPageProps {
    /** ID of the item we're currently focusing on (on what we last clicked on) */
    currentTreeViewFocus: string,
}


const AdaptCustomizationPage = (props: AdaptCustomizationPageProps) => {

    const { currentTreeViewFocus } = props;

    const { t } = useTranslation();

    const baseIds = useSelector(adaptSelectors.selectCustomizationBaseIds);
    const outputIds = useSelector(adaptSelectors.selectOutputIds);
    const customizationFetchError = useSelector((state: StoreState) => state.image.customizationFetchError);
    const appConfig = useSelector(appConfigSelectors.selectAppConfig);


    // detect what type of view we're currently presenting
    let currentViewType = CustomizationObjectType.None;
    if (outputIds.includes(currentTreeViewFocus)) {
        currentViewType = CustomizationObjectType.CustomizationOutput;
    } else if (baseIds.includes(currentTreeViewFocus)) {
        currentViewType = CustomizationObjectType.CustomizationBase;
    }

    return (
        <>
            {appConfig && appConfig.showErrorsInUi && customizationFetchError !== null ? (
                <PageSection variant={PageSectionVariants.light}>
                    <EmptyState>
                        <EmptyStateHeader titleText={<>{t('error.generic')}</>} headingLevel="h4" />
                        <EmptyStateBody>{t('error.customizationFetchFailed', { customizationFetchError: customizationFetchError })}</EmptyStateBody>
                    </EmptyState>
                </PageSection>
            ) : (
                <>
                    <AdaptCustomizationToolbar
                        currentView={currentViewType}
                        customizationOutputId={currentTreeViewFocus}
                    />
                    <PageSection variant={PageSectionVariants.light}>
                        {currentViewType === CustomizationObjectType.CustomizationOutput ? (
                            <AdaptCustomizationForm
                                outputId={currentTreeViewFocus}
                            />
                        ) : (
                            <EmptyState>
                                <EmptyStateBody>{t('customizationPage.selectCustomization.message')}</EmptyStateBody>
                            </EmptyState>
                        )
                        }
                    </PageSection>
                </>
            )}
        </>
    );
}

export default AdaptCustomizationPage;
